/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import type { Element } from 'react';
import React from 'react';
import moment from 'moment';
import get from 'lodash/fp/get.js';
import type {
  CellData,
  ColumnType,
} from '#components/pages/Models/Dashboard/ModelsTable/support/types';
import { disabled } from '#components/pages/Models/Dashboard/ModelsTable/ModelsTable.module.scss';

type CellType = (data: CellData) => Element<'span'>;

const accessor = (data: Object) => {
  const updatedAt = get('updatedAt', data);
  const date = new Date(updatedAt);
  return date.getTime();
};

const Cell: CellType = (data: Object) => {
  const updatedAt = get('row.updatedAt', data);
  const res = moment(updatedAt).format('MM/DD/YY');
  const archived = get('original.archived', data);
  return <span className={archived ? disabled : ''}>{res}</span>;
};

const column: ColumnType = {
  id: 'updatedAt',
  accessor,
  Header: 'Updated',
  width: 80,
  Cell,
  additionalClasses: ['text-right'],
};

export default column;
